/**
 * Enum representing different worker message types
 * 
 * This enum defines all possible message types that can be sent
 * between the worker and main thread for upload job management.
 */
export enum WorkerMessageType {
  // Request messages
  UPLOAD_REQUEST = 'UPLOAD_REQUEST',
  
  // Job control messages
  PAUSE_JOB = 'PAUSE_JOB',
  RESUME_JOB = 'RESUME_JOB',
  CANCEL_JOB = 'CANCEL_JOB',
  CANCEL_UPLOAD = 'CANCEL_UPLOAD',
  
  // Progress and status messages
  UPLOAD_PROGRESS = 'UPLOAD_PROGRESS',
  UPLOAD_COMPLETE = 'UPLOAD_COMPLETE',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  
  // Job status messages
  JOB_STARTED = 'JOB_STARTED',
  JOB_PAUSED = 'JOB_PAUSED',
  JOB_RESUMED = 'JOB_RESUMED',
  JOB_CANCELED = 'JOB_CANCELED',
  JOB_ERROR = 'JOB_ERROR',
}